import { createSlice } from '@reduxjs/toolkit';
import { INotSettledInstallments } from '../../models/repayment.model';


const initialState: INotSettledInstallments[] = [];

export const notSetteledSlice = createSlice({
    name: 'notSetteledInstallments',
    initialState,
    reducers: {
        getNotSeteledInstallments: (state: INotSettledInstallments[], action: any) => {
            return action.payload;
        },
    },
});

export const { getNotSeteledInstallments }: any = notSetteledSlice.actions;

export default notSetteledSlice.reducer;
